import { useNavigate } from 'react-router-dom';

const Button = ({ label, destination, className }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(destination);
  };

  // use <Button label="Beratung vereinbaren" destination="/kontakt" />

  return (
    <button
      onClick={handleClick}
      className={`px-6 py-3 bg-primary hover:bg-primary-light text-secondary-light font-semibold rounded-lg shadow-lg transition duration-300 ${className}`}
    >
      {label}
    </button>
  );
};

export default Button;
